import React, { useEffect, useState } from "react";

import {
  Box,
  Typography,
  Table,
  TableContainer,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import basestyle from "../../CSS/Base.module.css";
import assetsIcon from '../../../assets/images/game-icons_pay-money-removebg-preview.png'
import { getLoanSummaryByPId } from "../services/Summary/accountSummaryService";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { formatCurrency } from "../Utils/formatUtils";
import * as constants from "../../../constants";
import TableRowSummaryDesign from "./SummaryTableRowDesign";
import { useTranslation } from "react-i18next";
import CircularProgress from '@mui/material/CircularProgress';

function Labilities() {
  const navigate = useNavigate();
  const userInfo = useSelector((state: RootState) => state.auth);
  const [loading, setLoading] = useState(false);
  const [glNonAssets, setGLNonAssets] = useState<any>([]);
  const [glNonTotalBanalance, setGLNonTotoalBalance] = useState(0);
  const { t } = useTranslation();
  const translate = t as (key: string) => string;

  useEffect(() => {
    getLoanByPid(userInfo.defaultParticipantId, userInfo.clientId);
  }, [userInfo?.defaultParticipantId]);

  function handleNavigate(e: any, name: any) {
    e.preventDefault();
    if (name === constants.ACCOUNT_SUMMARY_LOAN_PAYABLE) {
      navigate(constants.PATH_LOAN_SUMMARY_PARTICIPANT);
    } else if (name === constants.ACCOUNT_SUMMARY_CREDIT_LINE) {
      navigate(constants.PATH_CREDITLINE_SUMMARY_PARTICIPANT);
    }
  }
  async function getLoanByPid(pId: number, clientId: number) {
    try {
      setLoading(true);
      const resLoanByPid = await getLoanSummaryByPId(pId, clientId);
      if (resLoanByPid.status == constants.STATUS_CODES.SUCCESS) {
        setGLNonAssets(resLoanByPid.data.data.glNonAssets);
        setGLNonTotoalBalance(resLoanByPid.data.data.totalBalance);
      }
    } catch (error) {
      console.error(translate("errorHandlingFundSource"), error);
    } finally {
      setLoading(false);
    }
  }


  return (
    <>
      <Paper sx={{ display: "flex", backgroundColor: "transparent", boxShadow: "none", borderRadius: "18px" }}>
        <Box className={`${basestyle.assetsContainer}`}>
          <Box className={`${basestyle.circleWhite}`}>
            <img src={assetsIcon} alt="Labilities Logo" className="LabilitiesLogo" style={{ width: "30px", height: "auto" }} />
          </Box>
          <Typography variant="h5" className={`${basestyle.assetsText}`}>
            {translate('liabilities')}
          </Typography>
        </Box>

        {loading ? (
          <Box className="loadingContainer">
            <CircularProgress size={20} />
            <Typography variant="body2" sx={{ marginTop: 1, ml: 1 }}>
              Loading...
            </Typography>
          </Box> 
        ) : (
          <TableContainer className={basestyle.mainTableContainer}>
            <Table size="small" sx={{ borderCollapse: "collapse" }}>
              <TableBody>
                {glNonAssets.map((item:any, index: React.Key | null | undefined) => (
                  <TableRowSummaryDesign key={index} variant="changeOddtoEven">
                    <TableCell
                      sx={{ cursor: "pointer", border: "none" }}
                      className={basestyle.tableCellStyle}
                    >
                      <Typography 
                        sx={{ color: "blue" }}
                        onClick={(e) => handleNavigate(e, item.glAcctName)}
                      >
                        {item.glAcctName}
                      </Typography>
                    </TableCell>
                    <TableCell
                      align="right"
                      className={`${basestyle.amountText} ${basestyle.tableCellStyle}`}
                      sx={{ border: "none" }}
                    >
                      {formatCurrency(item.glAcctBalance)}
                    </TableCell>
                  </TableRowSummaryDesign>
                ))}

                {/* Total Available Balance Row */}
                <TableRow className={basestyle.totalAmountStyle}>
                  <TableCell className={basestyle.tableCellStyle} sx={{ border: "none" }} />
                  <TableCell
                    align="right"
                    className={basestyle.tableCellStyle}
                    sx={{ border: "none" }}
                  >
                    <Typography>
                      <span className={basestyle.labelBoldText}>
                        {translate("totalAvailableBalance")}
                      </span>
                      &nbsp;
                      <span
                        className={basestyle.amountTotalAvaliable}
                        style={{display: "inline-block", fontWeight:"bold" }}
                      >
                        {formatCurrency(glNonTotalBanalance)}
                      </span>
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        )}


      </Paper>

    </>

  );
}
export default Labilities;
